import { ProgressTimerMobile } from './ProgressTimerMobile'

export interface ProgressTimerProps {
  timeLeft: number
  progress: number
}

export const ProgressTimer = (props: ProgressTimerProps) => {
  return (
    <>
      <ProgressTimerMobile {...props} />
    </>
  )
}
